import type { UserDto } from '@/dtos/user.dto'
import type { User } from '@/models/user.model'
import { ROLES, type Role } from '@/constants'

function toRole(value: string | undefined): Role {
  const validRoles = Object.values(ROLES) as string[]
  // Falls back to the least-privileged role rather than a generic "Usuario"
  // (removed) — never default an unrecognized role into elevated access.
  return value !== undefined && validRoles.includes(value) ? (value as Role) : ROLES.PATIENT
}

function splitName(fullName: string): { firstName: string; lastName: string } {
  const parts = fullName.trim().split(/\s+/)
  return {
    firstName: parts[0] ?? '',
    lastName: parts.length > 1 ? parts.slice(1).join(' ') : '',
  }
}

export function toUser(dto: UserDto): User {
  const { firstName, lastName } = splitName(dto.fullName)

  return {
    id: dto.id,
    username: dto.username,
    email: dto.email,
    firstName,
    lastName,
    fullName: dto.fullName,
    role: toRole(dto.roles[0]?.name),
    menuSections: dto.roles[0]?.menuSections ?? [],
    isActive: dto.isActive,
    createdAt: dto.createdAt !== undefined ? new Date(dto.createdAt) : undefined,
  }
}
